import { Component } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { NavigatePageAccueil, NavigatePageInvitation, NavigatePageResultat } from '../../state/preautorisation.actions';
import { FeatureValue } from '../../../../lib-feature-decision/decorators/feature-value.decorator';
import { ParcoursDsdFeatures } from '../../../../parcours-dsd/parcours-dsd.features';
import { PreautorisationSelectors } from '../../state/preautorisation.selectors';
import { Observable } from 'rxjs';
import { StatusPreautorisation } from '../../../../shared/modeles/variables';
import * as moment from 'moment';
import { AppConfigService } from '../../../../app-config.service';
import { TypeProjet } from '../../../../shared/constants/type-projet.enum';
import { TauxGarantiModel } from '../../models/taux-garanti.model';
import { TypeEmprunteurEnum } from '../../constants/type-emprunteur.enum';

@Component({
  selector: 'app-dashboard-card-status',
  templateUrl: './dashboard-card-status.component.html',
  styleUrls: ['dashboard-card-status.component.scss'],
  standalone: false
})
export class DashboardCardStatusComponent {
  StatusPreautorisation = StatusPreautorisation;
  TypeEmprunteurEnum = TypeEmprunteurEnum;

  @FeatureValue(ParcoursDsdFeatures.PreautorisationDisabled)
  isPreautorisationDisabled: boolean;

  @Select(PreautorisationSelectors.statutPreautorisation)
  statutPreautorisation$: Observable<StatusPreautorisation>;

  @Select(PreautorisationSelectors.dateExpirationPreaut)
  dateExpirationPreaut$: Observable<Date>;

  @Select(PreautorisationSelectors.dateExpirationTaux)
  dateExpirationTaux$: Observable<Date>;

  @Select(PreautorisationSelectors.montantPreautorise)
  montantPreautorise$: Observable<number>;

  @Select(PreautorisationSelectors.montantDemande)
  montantDemande$: Observable<number>;

  @Select(PreautorisationSelectors.montantPropose)
  montantPropose$: Observable<number>;

  @Select(PreautorisationSelectors.dateExpirationSelectionTaux)
  dateExpirationSelectionTaux$: Observable<number>;

  @Select(PreautorisationSelectors.dateExpirationCodeInvitation)
  dateExpirationCodeInvitation$: Observable<string>;

  @Select(PreautorisationSelectors.codeInvitation)
  codeInvitation$: Observable<string>;

  @Select(PreautorisationSelectors.isCoemprunteur)
  isCoemprunteur$: Observable<boolean>;

  @Select(PreautorisationSelectors.isEmprunteurSecondaire)
  isEmprunteurSecondaire$: Observable<boolean>;

  @Select(PreautorisationSelectors.typeEmprunteur)
  typeEmprunteur$: Observable<TypeEmprunteurEnum>;

  @Select(PreautorisationSelectors.tauxPreautorisation)
  taux$: Observable<TauxGarantiModel[]>;

  @Select(PreautorisationSelectors.dateAnnulationContreOffre)
  dateAnnulationContreOffre$: Observable<Date>;

  typeProjet: TypeProjet;

  constructor(private readonly _store: Store, readonly appConfigService: AppConfigService) {
    this.typeProjet = this.appConfigService.typeProjet;
  }

  navigatePageAccueil() {
    this._store.dispatch(new NavigatePageAccueil());
  }

  navigatePageInvitation() {
    this._store.dispatch(new NavigatePageInvitation());
  }

  navigatePageResultat() {
    this._store.dispatch(new NavigatePageResultat());
  }

  isDateExpiringSoon(date: Date) {
    const notificationStartDate = moment(date)
      .subtract('30', 'days')
      .toDate();

    const today = new Date();
    return today >= notificationStartDate && today <= date;
  }

  getTexteEnAttenteSelectionTaux() {
    const isCoemprunteur = this._store.selectSnapshot(PreautorisationSelectors.isCoemprunteur);
    const isEmprunteurSecondaire = this._store.selectSnapshot(PreautorisationSelectors.isEmprunteurSecondaire);

    if (!isCoemprunteur || isEmprunteurSecondaire) {
      return '';
    } else {
      return '-coemprunteur-principal';
    }
  }
}
